import { ClinicFormData, ClinicMainInfoFormData, ClinicOtherInfoFormData } from 'models/forms';
import { DEFAULT_LOCALE_FORMAT } from 'models/locale-format';

export const emptyClinicFormData = () => {
    return {
        name: '',
        localLabOwner: undefined,
        officialName: '',
        organizationNumber: '',
        ptjCustomerNumber: '',
        gln: '',
        parentClinicId: '',
        contact: {
            address: {
                street: '',
                postalCode: '',
                city: '',
                country: '',
            },
            postalAddress: {
                street: '',
                postalCode: '',
                city: '',
                country: '',
            },
            communication: {
                phone: '',
                email: '',
                site: '',
            },
        },
        isNotPickUpAndDeliveryPlace: false,
        invoicing: {
            vatNo: '',
            invoiceAddress: {
                postalCode: '',
                street: '',
                city: '',
                country: '',
            },
            communication: {
                phone: '',
                email: '',
                site: '',
            },
        },
        externalInfo: {
            externalId1: '',
            externalId2: '',
        },
        localeFormat: DEFAULT_LOCALE_FORMAT,
    } as ClinicFormData;
};

export const emptyOtherInfoFormData = () => {
    return {
        costCenter: '',
        gln: '',
        email: '',
        phone: '',
        site: '',
        vatNo: '',
        invoiceEmail: '',
    } as ClinicOtherInfoFormData;
};

export const emptyMainInfoFormData = () => {
    return {
        name: '',
        officialName: '',
        organizationNumber: '',
        address: undefined,
        localLabOwner: undefined,
        ptjCustomerNumber: '',
    } as ClinicMainInfoFormData;
};
